import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { useContext } from "react";
import { FormContainer, useForm } from "react-hook-form-mui";
import UserProfileViewModel from "../Admin/User/ViewModels/UserProfileViewModel";
import { APIContext } from "../Contexts/APIContext";
import ReturnViewModel from "../Contexts/ReturnViewModel";
import RenderTextField from "../Utilities/Forms/RenderTextField";
import ChangeNameViewModel from "./ViewModels/ChangeNameViewModel";

interface IProps {
    dialogOpen: boolean;
    handleClose: () => void;
    user?: UserProfileViewModel;
}
export default function ChangeNameDialog({ dialogOpen, handleClose, user }: IProps) {
    const { post, showMessage } = useContext(APIContext);

    const formContextName = useForm<ChangeNameViewModel>({
        defaultValues: new ChangeNameViewModel(),
    });

    const updateName = (data: ChangeNameViewModel) => {
        if (user?.id == null) {
            showMessage("error", "User Not Found")
            return;
        }
        data.id = user.id;
        post('Auth', 'ChangeName', data, async (response: ReturnViewModel) => {
            if (response)
                showMessage('success', "Name successfully updated")
            handleCloseAndReset();
        });

    };

    const handleCloseAndReset = () => {
        formContextName.reset(new ChangeNameViewModel());
        handleClose();
    };

    return (
        <Dialog open={dialogOpen} onClose={handleCloseAndReset} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Typography variant={"h6"}>Change Password</Typography>
            </DialogTitle>
            <FormContainer formContext={formContextName} onSuccess={updateName}>
                <DialogContent>
                    <Grid container alignItems="center" sx={{ mt: 2 }}>
                        <Grid size={12}>
                            <RenderTextField label="First Name:" name="firstName" readOnly={false} alwaysShow={true} labelSize={12} inputSize={12} required />
                        </Grid>
                        <Grid size={12}>
                            <RenderTextField label="Last Name:" name="lastName" readOnly={false} alwaysShow={true} labelSize={12} inputSize={12} required />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button fullWidth={false} onClick={handleCloseAndReset}>Cancel</Button>
                    <Button fullWidth={false} type="submit">Submit</Button>
                </DialogActions>
            </FormContainer>
        </Dialog>
    )
}